import moment, { Moment } from "moment";
import { WEBSITE_ORDER_CHANNEL } from "@/constants/orderChannel";
import { getAssetBaseUrl } from "@/config/api";
import { getRestaurantId } from "@/config/restaurant-id";
import { getCookieValue as getCookieValueImpl } from "@/utils/cookies";
import { formatMoney } from "@/utils/locale-format";

export const getCookieValue = getCookieValueImpl;
export { getRestaurantId };

export const capitalizeWords = (str: string = "", lower = false): string => {
  return (lower ? str.toLowerCase() : str).replace(
    /(?:^|\s|["'([{])+\S/g,
    (match) => match.toUpperCase()
  );
};

export const camelCaseWords = (inputString: string): string => {
  return inputString
    ?.toLowerCase()
    ?.replace(/\b[a-z]/g, (letter) => letter.toUpperCase());
};

export const titleCaseWords = (inputString: string): string => {
  return inputString
    ?.replace(/_/g, " ")
    ?.replace(/\b\w/g, (letter) => letter.toUpperCase());
};

/** Format order_status for display: e.g. "pending" → "Pending", "out_for_delivery" → "Out For Delivery" */
export const formatOrderStatus = (s: string = ''): string =>
  titleCaseWords((s || '').toLowerCase());

/** Rounds to 2 decimals for currency calculations (avoids floating-point errors). NaN/invalid → 0. */
export function roundPrice(value: unknown, decimals = 2): number {
  const n = Number(value);
  if (!Number.isFinite(n)) return 0;
  const factor = Math.pow(10, decimals);
  return Math.round((n + Number.EPSILON) * factor) / factor;
}

/** @deprecated Use `formatMoney` from `@/utils/locale-format`. */
export const currencyFormatter = formatMoney;

export const getFirstErrorMessage = (response: Record<string, unknown> | unknown): string | undefined => {
  if (response == null || typeof response !== 'object') return undefined;
  const errors = response as Record<string, unknown>;
  const firstKey = Object.keys(errors)?.[0];
  const firstVal = errors?.[firstKey];
  if (Array.isArray(firstVal) && firstVal.length > 0) return String(firstVal[0]);
  return undefined;
};

export const scrollToTop = (): void => {
  const scrollContainer = document.getElementById("mainContainer");
  if (scrollContainer) {
    scrollContainer.scrollTop = 0;
  }
};

export const getIndianTime = (value: string): Moment => {
  return moment(value).utcOffset(330);
};

export function convertUTCToIST(utcDateTime: string): Moment {
  return moment.utc(utcDateTime).add(5, "hours").add(30, "minutes");
}

export const cartDisplayPages = ["/", "/categories", "/my-orders", "/dishes"];

export const pagesWithNavigation = [
  "/",
  "/categories",
  "/my-account",
  "/dishes",
];

export {
  formatCurrency,
  formatMoney,
  formatNumber,
  getCountryIso2,
  getCurrencyCode,
  getCurrencySymbol,
} from "@/utils/locale-format";
export const orderChannel = WEBSITE_ORDER_CHANNEL;
export const orderType = 3;
export const orderSource = 2; // backend OrderSource.Website (3 is Table/QR)

// API origin used for resolving relative media paths (AppImage baseUrl).
export const serverUrl = getAssetBaseUrl();
export const SAMPLE_UUID = "00000000-0000-0000-0000-000000000000";
